<template>
  <!-- :is="isDisabled ? 'span' : 'router-link'" -->
  <ul class="navbar-nav mr-auto navbar-navigation">
    <li v-for="(value, index) in routes" :key="index">
      <router-link
        :is="value.label"
        :to="{ name: value.item.name }"
        :style="value.item.style"
        v-bind:class="[
          analysis === value.item.analysis
            ? 'link-selected nav-item'
            : 'nav-item',
          value.item.class
        ]"
      >
        {{ value.item.show_name }}
      </router-link>
    </li>
  </ul>
</template>
<script>
export default {
  name: "RouterLinkComponent",
  props: {
    analysis: { type: String, required: true }
  },
  data() {
    return {
      routes: this.$store.state.user_routes.all.items
    };
  }
};
</script>

<style scoped>
@media (max-width: 1100px) {
  .navbar-navigation {
    text-align: center;
  }
}
</style>
